/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

export default function HasPermission({ permission, children }) {
    if (permission) return children;

    return (<div />)
}

